import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  /**
   * Grow to fill a flex parent and centre within it. For a height-filling table
   * card, where a natural-height block would leave the footer stranded
   * mid-card with dead space beneath it.
   */
  fillHeight?: boolean;
}

export function EmptyState({ icon, title, description, action, fillHeight = false }: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center px-6 text-center ${
        fillHeight ? 'min-h-0 flex-1 py-10' : 'py-16'
      }`}
    >
      {icon && <div className="text-text-muted mb-4">{icon}</div>}
      <h3 className="text-text-primary text-lg font-semibold">{title}</h3>
      {description && <p className="text-text-secondary mt-2 max-w-sm text-sm">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
